module.exports = __webpack_public_path__ + "assets/images/fdb698566e927c9a46691517a7f51202.png";